"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExperimentTreatments;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var initialState = {
  isLoading: false,
  hasErrors: false,
  treatments: []
};

function ExperimentTreatments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;

  switch (type) {
    case _ActionTypes.EXPERIMENT_TREATMENTS_REQUESTED:
      return (0, _extends2.default)({}, state, {
        isLoading: true
      });

    case _ActionTypes.EXPERIMENT_TREATMENTS_RECEIVED:
      return {
        isLoading: false,
        hasErrors: false,
        treatments: payload.treatments
      };

    case _ActionTypes.EXPERIMENT_TREATMENTS_FAILED:
      if (error) {
        console.error(error);
      }

      return {
        isLoading: false,
        hasErrors: true
      };

    default:
      return state;
  }
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/ExperimentTreatments.js
// module id = 536
// module chunks = 5 6